<template>
    <div class="radio d-flex align-items-center" v-disabled="disabled">
        <span class="radio-icon" @click="handleClick" v-c:checked="checked"/>
        <span class="radio-label" @click="handleClick">
            <slot><span v-html="label"/></slot>
        </span>
    </div>
</template>

<script>
    import {matchesSelector} from '../helper';

    export default {
        props: {
            label: {required: false, type: String},
            set: {type: [String, Number], required: true}, // set: the value the radiobox emits when clicked
            value: {type: [String, Number], required: null},
            disabled: {type: Boolean, default: false},
        },

        computed: {
            checked() {
                return this.value == this.set;
            },
        },

        methods: {
            handleClick(event) {
                if (!matchesSelector(event.target, '.prevent, .prevent *')) {
                    this.$emit('input', this.set);
                }
            },
        },
    };
</script>